import React from 'react'
import PropTypes from 'prop-types'
const styles = {
    col1: {
        fill: '#FF6600',
        fillRule: 'nonzero',
    },
}

const fanSystemsSVG = ({ classes, color, width, height }) => (
    <svg viewBox="0 0 24 24" width={width} height={height}>
                <g>
                    <path
                        d=" M 22.526 15.644 L 22.526 22.666 L 5.163 22.666 L 5.163 15.644 L 22.526 15.644 Z  M 23 15.17 L 23 15.17 L 4.689 15.17 L 4.689 23.14 L 23 23.14 L 23 15.17 Z "
                        style={{ fill: color }}/>
                </g>
                <g>
                    <path
                        d=" M 22.526 15.644 L 22.526 22.666 L 5.163 22.666 L 5.163 15.644 L 22.526 15.644 Z  M 23 15.17 L 23 15.17 L 4.689 15.17 L 4.689 23.14 L 23 23.14 L 23 15.17 Z "
                        style={{ fill: color }}/>
                </g>
                <path d=" M 9.845 21.985 L 7.504 21.985 L 7.504 21.037 L 9.845 21.037 L 9.845 21.985 Z "
                      style={{ fill: color }}/>
                <path d=" M 22.052 17.274 L 12.66 17.274 L 12.66 16.355 L 22.052 16.355 L 22.052 17.274 Z "
                      style={{ fill: color }}/>
                <path d=" M 22.052 19.615 L 15 19.615 L 15 18.696 L 22.052 18.696 L 22.052 19.615 Z "
                      style={{ fill: color }}/>
                <path d=" M 22.052 21.985 L 14.082 21.985 L 14.082 21.037 L 22.052 21.037 L 22.052 21.985 Z "
                      style={{ fill: color }}/>
                <g>
                    <path
                        d=" M 9.519 6.696 C 9.578 6.696 9.637 6.696 9.697 6.696 C 9.786 6.726 9.904 6.756 9.993 6.756 C 10.674 6.933 11.267 7.348 11.652 7.941 C 13.489 7.289 15.356 7.763 16.956 8.593 C 17.548 8.919 18.23 8.415 18.111 7.763 C 17.845 6.341 17.311 5.156 16.452 4 C 16.156 3.585 15.474 2.815 15 2.548 C 14.348 2.193 13.637 2.222 13.015 2.548 C 11.8 3.2 10.674 4.089 9.963 5.304 C 9.815 5.6 9.667 5.896 9.578 6.193 C 9.519 6.341 9.46 6.519 9.43 6.667 C 9.4 6.726 9.489 6.696 9.519 6.696 Z "
                        style={{ fill: color }}/>
                    <path
                        d=" M 3.741 14.222 L 8.215 14.222 C 8.423 13.985 8.63 13.718 8.778 13.422 C 8.956 13.155 9.074 12.859 9.193 12.563 C 9.252 12.385 9.282 12.237 9.341 12.089 C 9.341 12.03 9.252 12.059 9.223 12.059 C 9.163 12.059 9.134 12.03 9.074 12.03 C 8.956 12.03 8.867 12 8.778 11.97 C 8.067 11.822 7.504 11.407 7.119 10.815 C 5.282 11.467 3.415 10.963 1.786 10.133 C 1.193 9.837 0.512 10.341 0.63 10.993 C 0.897 12.415 1.43 13.6 2.319 14.755 C 2.615 15.141 3.267 15.911 3.741 16.178 L 3.741 14.222 Z "
                        style={{ fill: color }}/>
                    <path
                        d=" M 16.185 13.007 C 15.534 11.822 14.645 10.667 13.43 9.956 C 13.163 9.807 12.867 9.659 12.571 9.57 C 12.393 9.511 12.245 9.452 12.097 9.422 C 12.008 9.393 12.067 9.481 12.067 9.511 C 12.037 9.57 12.037 9.63 12.037 9.689 C 12.037 9.778 12.008 9.896 11.978 9.985 C 11.83 10.667 11.415 11.259 10.823 11.644 C 11.119 12.504 11.178 13.392 11.06 14.222 L 16.452 14.222 C 16.511 13.807 16.422 13.392 16.185 13.007 Z "
                        style={{ fill: color }}/>
                    <path
                        d=" M 7.919 9.363 C 7.919 10.193 8.571 10.844 9.371 10.844 C 10.2 10.844 10.852 10.193 10.852 9.363 C 10.852 8.563 10.2 7.911 9.371 7.911 C 8.571 7.911 7.919 8.563 7.919 9.363 Z "
                        style={{ fill: color }}/>
                    <path
                        d=" M 4.719 8.385 C 5.193 8.741 5.697 9.007 6.23 9.185 C 6.349 9.244 6.467 9.274 6.586 9.304 C 6.615 9.304 6.645 9.304 6.675 9.333 C 6.734 9.333 6.704 9.274 6.704 9.244 C 6.704 9.185 6.704 9.096 6.734 9.037 C 6.763 8.711 6.852 8.415 7 8.119 C 7.149 7.852 7.326 7.615 7.563 7.407 C 7.682 7.289 7.8 7.2 7.919 7.111 C 7.978 7.082 7.889 6.993 7.889 6.963 C 7.889 6.904 7.86 6.844 7.83 6.785 C 7.682 6.222 7.623 5.659 7.652 5.096 C 7.712 3.882 8.067 2.845 8.6 1.778 C 8.926 1.185 8.423 0.534 7.771 0.622 C 6.349 0.889 5.163 1.422 4.008 2.282 C 3.623 2.608 2.823 3.289 2.556 3.733 C 2.201 4.356 2.201 5.096 2.556 5.719 C 3.119 6.756 3.771 7.644 4.719 8.385 Z "
                        style={{ fill: color }}/>
                </g>
                <path d=" M 9.845 19.852 L 6.082 19.852 L 6.082 16.563 L 9.845 16.563 L 9.845 19.852 Z "
                      style={ styles.col1 }/>
    </svg>
)

fanSystemsSVG.defaultProps = {
    color: '#fff',
    width: 24,
    height: 24,
}

fanSystemsSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default fanSystemsSVG
